import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import PositionsView from "@/features/R1Dashboard/views/PositionsView";

export default function R1Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <PositionsView />
      </main>
    </R1DashboardProvider>
  );
}
